import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import {Spin, Icon} from 'antd'

import style from './cards.sass'

const antIcon = <Icon type="loading" style={{fontSize:12, color:'#fff', position:'absolute', top:0, left:0}} spin />

class Cards extends Component {
  render() {
    const {currentPlanID, upgrade, loading} = this.props
    return(
      <section styleName='wrapper'>
        <div className='landing-container' styleName='container'>
          <h2>Algoriz Pricing</h2>
          <p styleName='slogan'>Trade smarter with the most innovative Trading technology.</p>
          <div styleName='grid'>
            <div styleName='card'>
              <h3 styleName='lite'>Lite</h3>
              <span styleName='description'>Essentials for Beginners</span>
              <span styleName='price'>Free</span>
              <span styleName='period'></span>
            </div>
            <div styleName='card'>
              <h3 styleName='professional'>Professional</h3>
              <span styleName='description'>Advanced features for Professionals</span>
              <span styleName='price'>$29</span>
              <span styleName='period'>per month</span>
              {currentPlanID < 2 &&
                <button type='button' onClick={() => upgrade(2)}>
                  {loading ? <Spin indicator={antIcon} size='small'/> : 'Upgrade'}
                </button>
              }
            </div>
            <div styleName='card'>
              <h3 styleName='premium'>Premium</h3>
              <span styleName='description'>Complete Solution for your Trading needs</span>
              <span styleName='price'>$69</span>
              <span styleName='period'>per month</span>
              {currentPlanID < 3 &&
                <button type='button' onClick={() => upgrade(3)}>
                  {loading ? <Spin indicator={antIcon} size='small'/> : 'Upgrade'}
                </button>
              }
            </div>
            <div styleName='card'>
              <h3 styleName='enterprise'>Enterprise</h3>
              <span styleName='description'>Customized Solution for your trading house</span>
              <span styleName='price'>Custom</span>
              <span styleName='period'>Custom</span>
              {currentPlanID < 4 &&
                <Link to='/contact'>
                  <button type='button'>Contact Us</button>
                </Link>
              }
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Cards
